import type { FaireProductEntity } from "../../entity_types/product";

export const p_mrvd54gp4f: FaireProductEntity = {
  token: "p_mrvd54gp4f",
  type: "product",
  name: "Fir Real",
  brandToken: "b_9n6zhnblbf",
  brandName: "Geometry",
  imageUrl:
    "https://cdn.faire.com/fastly/ba2554a446cc65c5777a9f62c6de242db754c3f32ac21b255afafbb9d3777227.jpeg",
  galleryImageUrls: [],
  priceDollars: 9,
  description:
    'Kitchen Tea Towel\n\nThrow in the (ordinary) towel.\n\nMeet the product that started it all. The Geometry House Tea Towel is a cult favorite for a reason. Created from a tightly-woven Geoweave™ fabric that is ultra-absorbent, quick-drying and never wrinkles, this towel is built to work – while looking like a dream.\n\n...\n\n• ♺ Made from post-consumer recycled materials\n• 18" x 30"\n• Single-sided print\n• 100% Satisfaction Guarantee\n• No questions asked, hassle-free returns\n\n...\n\nChore responsibly.\n\nFrom drying dishes to wiping up spills to accenting your kitchen with the season’s most enchanting prints, this Tea Towel does it all – without a negative impact on the environment. Our towels are created from post-consumer recycled products using less water than traditional methods and minimizing our carbon footprint. And due to its patented weave, high absorbency and quick dry time, you can clean with fewer harsh chemicals and wash it less often, reducing yours.\n\nImpact your home, not the environment. Discover the Geometry Tea Towel.',
  tags: [],
  msrpDollars: 18,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-23T04:52:16.514Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
